/** Normaliza texto para búsquedas: minúsculas, sin acentos y espacios simples. */
export function normalizarBusqueda(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** ¿Contiene `texto` todas las palabras de `consulta` (ignorando acentos)? */
export function coincideBusqueda(texto: string, consulta: string): boolean {
  const base = normalizarBusqueda(texto);
  return normalizarBusqueda(consulta)
    .split(' ')
    .filter(Boolean)
    .every((palabra) => base.includes(palabra));
}
